import React, { useState, useEffect, useCallback } from 'react';
import {
  C, S, Badge, StatusBadge, FormField, ErrList, StatCard,
  PageHeader, FilterBar, DataTable, Modal, FormGrid,
  useToast, useConfirm, useCRUD,
} from '../../components/inventoryShared';
// Simple form modal wrapper
const FormModal = ({ title, onClose, onSave, saving, children, maxWidth=640 }) => (
  <Modal title={title} onClose={onClose} maxWidth={maxWidth}
    footer={
      <>
        <button style={S.btnSec} onClick={onClose}>Cancel</button>
        <button style={S.btnPri} onClick={onSave} disabled={saving}>
          {saving ? 'Saving...' : 'Save'}
        </button>
      </>
    }>
    {children}
  </Modal>
);
export default FormModal;